export default __webpack_public_path__ + "static/media/Zeus-6.966201ac.pdf";